<template>
  <div>
    <b-row
      match-heigth
    >
      <b-col
        cols="12"
        md="8"
      >
        <b-card>
          <project-select />
          <keyword-tags />
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <image-card />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import ProjectSelect from '@/views/Admin/Zenno_stocks/elements/ProjectSelect.vue'
import KeywordTags from '@/views/Admin/Zenno_stocks/elements/KeywordTags.vue'
import ImageCard from '@/views/Admin/Zenno_stocks/elements/ImageCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    ProjectSelect,
    KeywordTags,
    ImageCard,
  },
  computed: {
    dataItem() {
      return this.$store.getters['zennoStocks/dataItem']
    },
  },
}
</script>
